import { Env } from '../contexts/AppContext';
import { IMGIX_ENV, IMGIX_URL } from '../src/env';

interface getImgxSrcParams {
  path: string;
  isDevDependence: boolean;
  envContext?: Env;
}

export const getImgxSrc = ({ path, isDevDependence, envContext }: getImgxSrcParams) => {
  const env = isDevDependence ? 'global' : envContext?.IMGIX_ENV || IMGIX_ENV;
  const root = envContext?.IMGIX_URL || IMGIX_URL;

  return `${root}/${env}/${path}`;
};

export const getArticleImgSrc = (id?: number, picture?: string) => {
  if (!picture) {
    return getImgxSrc({ path: `/articles/article_default.jpg`, isDevDependence: false });
  }

  return getImgxSrc({ path: `/articles/${id}/${picture}`, isDevDependence: false });
};
